// import './App.css';
// import React from 'react';
// import { Outlet, useLocation } from 'react-router-dom';
// import { useState, useEffect } from 'react';
// import { ConfigProvider, Divider, Grid, Layout, theme } from 'antd';
// import { useSelector } from 'react-redux';

// import Logo from "./images/logo.png";
// import Logodark from "./images/logodark.png";
// import Logo1 from "./images/logolong.png";
// import Logo1dark from "./images/logolongdark.png";

// import Sidebar from './screens/global/Sidebar';
// import Topbar from './screens/global/Topbar';

// const { Content, Footer, Sider } = Layout;

// function App() {
//   const { darkAlgorithm, compactAlgorithm } = theme;

//   const { userInfo } = useSelector((state) => state.auth);

//   const { useBreakpoint } = Grid;
//   const screens = useBreakpoint();

//   const [collapsed, setCollapsed] = useState(false);

//   const { pathname } = useLocation();

// // Open every page from the top when the route changes
// useEffect(() => {
//   window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
//   document.documentElement.scrollTop = 0;
//   document.body.scrollTop = 0;

//   // in case the page content scrolls inside its own container
//   document
//     .querySelectorAll('.site-layout, .ant-layout-content')
//     .forEach((el) => { el.scrollTop = 0; });
// }, [pathname]);

// useEffect(() => {
//   if (screens.lg === false) setCollapsed(true);
// }, [screens.lg, pathname]);

//   const onCollapse = () => {
//     setCollapsed(!collapsed);
//   };

//   const isCompactMode = false;

//   return (
//     <>
//       <ConfigProvider
//         theme={{
//           components: {
//             Table: {
//               headerBg: "#2f3640",
//               headerColor: "whitesmoke",
//             },
//           },

//           // Always use dark theme
//           algorithm: isCompactMode
//             ? [darkAlgorithm, compactAlgorithm]
//             : [darkAlgorithm],
//         }}
//       >
//         {userInfo ? (
//          <Layout style={{ minHeight: '100vh' }}>

//   <Sider
//     collapsed={collapsed}
//     onCollapse={onCollapse}
//     className="sidebar"
//     theme="dark"
//     breakpoint="lg"
//     collapsedWidth={screens.lg ? 80 : 0}
//     trigger={null}
//     width={200}
//     style={{
//       backgroundColor: "#0b0b0b",
//       boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.35)",
//     }}
//   >

//     {collapsed && (
//       <img
//         src={Logodark}
//         height="25px"
//         style={{
//           margin: "16px",
//           marginLeft: "30px",
//         }}
//         alt="logo"
//       />
//     )}

//     {!collapsed && (
//       <img
//         src={Logo1dark}
//         height="25px"
//         style={{
//           margin: "16px",
//           marginLeft: "30px",
//         }}
//         alt="logodark"
//       />
//     )}

//     <Sidebar />

//   </Sider>

//   <Layout className="site-layout">

//     <Topbar
//       setCollapsed={setCollapsed}
//       collapsed={collapsed}
//       screens={screens}
//     />

//     <Content
//       className={`content-wrapper ${
//         collapsed || screens.lg ? '' : 'blurred'
//       }`}
//       style={{ margin: '20px' }}
//     >
//       <Outlet />
//     </Content>

//     <Divider />

//     <Footer style={{ textAlign: 'center' }}>
//       Lincfolio © {new Date().getFullYear()}
//     </Footer>

//   </Layout>

//   </Layout>
//         ) : (
//           <Outlet />
//         )}
//       </ConfigProvider>
//     </>
//   );
// }

// export default App;


import './App.css';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ConfigProvider, Divider, Grid, Layout, theme } from 'antd';
import { useSelector } from 'react-redux';

import BrandLogo from './components/BrandLogo';

import Sidebar from './screens/global/Sidebar';
import Topbar from './screens/global/Topbar';

const { Content, Footer, Sider } = Layout;

function App() {
  const { darkAlgorithm, compactAlgorithm } = theme;

  const { userInfo } = useSelector((state) => state.auth);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState(false);

  const { pathname } = useLocation();

  // Open every page from the top when the route changes
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // in case the page content scrolls inside its own container
    document
      .querySelectorAll('.site-layout, .ant-layout-content')
      .forEach((el) => { el.scrollTop = 0; });
  }, [pathname]);

  // on phones / small screens keep the menu closed after opening a page
  useEffect(() => {
    if (screens.lg === false) setCollapsed(true);
  }, [screens.lg, pathname]);

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  const isCompactMode = false;

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#2f3640",
              headerColor: "whitesmoke",
            },
          },

          // Always use dark theme
          algorithm: isCompactMode
            ? [darkAlgorithm, compactAlgorithm]
            : [darkAlgorithm],
        }}
      >
        {userInfo ? (
          <Layout style={{ minHeight: '100vh' }}>

            <Sider
              collapsed={collapsed}
              onCollapse={onCollapse}
              className="sidebar"
              theme="dark"
              breakpoint="lg"
              collapsedWidth={screens.lg ? 80 : 0}
              trigger={null}
              width={200}
              style={{
                backgroundColor: "#0b0b0b",
                boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.35)",
              }}
            >

              {/* LF mark + LINCFOLIO name (mark only when the menu is collapsed) */}
              <BrandLogo
                variant="dark"
                height={26}
                iconOnly={collapsed}
                style={{
                  margin: collapsed ? "16px 0" : "16px 16px 16px 24px",
                  justifyContent: collapsed ? "center" : "flex-start",
                }}
              />

              <Sidebar />

            </Sider>

            <Layout className="site-layout">

              <Topbar
                setCollapsed={setCollapsed}
                collapsed={collapsed}
                screens={screens}
              />

              <Content
                className={`content-wrapper ${
                  collapsed || screens.lg ? '' : 'blurred'
                }`}
                style={{ margin: '20px' }}
              >
                <Outlet />
              </Content>

              <Divider />

              <Footer style={{ textAlign: 'center' }}>
                Lincfolio © {new Date().getFullYear()}
              </Footer>

            </Layout>

          </Layout>
        ) : (
          <Outlet />
        )}
      </ConfigProvider>
    </>
  );
}

export default App;
